// Mutations
export const START_VIEW_LOADER = 'START_VIEW_LOADER';
export const STOP_VIEW_LOADER = 'STOP_VIEW_LOADER';
